import React, { Component } from 'react'
import { MDBContainer, MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';

export default class MakeUp extends Component {
  render() {
    return (
        	<div class="container white_background">
		<div class="row justify-content-center Concepts_intro no-gutters">
			<div class="col-0 col-sm-0 col-md-0 col-lg-4 col-xl-4 Concepts_intro_title_B ">
			    <p class="Concepts_line2">Make-up<br />POWER<br />Weeks</p>
			</div>
			<div class="col Concepts_intro_content justify-content-center">
				<div class="row Concepts_intro_brief justify-content-center no-gutters">
					<p>Not your best week? You have the option to complete a <font style={{color:"#3c5b89"}}>Make-Up POWER Week</font>, which will start one week later. </p>
					<p>Because we need complete data, we encourage you to complete a Make-Up and have another chance to earn badges.</p>
				</div>
				<div class="row makeup_power_week_calendar">
					<div class="col-12 col-sm-12 col-md-10 col-lg-8 col-xl-8">
						<img src="https://i.ibb.co/bRBP866/slice52-3x.png" alt="slice52-3x" border="0" class="makeup_power_week_calendar_img"/>
					</div>
					<div class="col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6 makup_power_week_calendar_notes">
						<p class="calendar_notes_h"><img src="https://i.ibb.co/Y3t2Pvg/slice50-3x.png" alt="slice50-3x" border="0" class="list_style_tri"/> Start</p>
					    <p class="calendar_notes_p">2 weeks later, on Monday </p>
					</div>
				</div>
		<div class="row">
			<div class="col"></div>
			<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6">
                <MDBNavLink class="nav-link" to="/oneMoreStep">
				   <a href="#" class="Bottom_button_r">
				   <p>One More Step!</p>
				   </a>
                </MDBNavLink>
            </div>
			<div class="col"></div>
		</div>
			</div>
		</div>
	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MakeUp.js